import { Button, Form, Grid, Input, Typography } from 'antd';

import AppModal from '@components/app-modal';
import { useSetAccountCPF } from '@lib/api/hooks/accounts/use-set-account-cpf';
import { maskBRCPF } from '@lib/utils/masks';
import { CPFRule, requiredRule } from '@lib/utils/validator-rules';

const FORM_ID = 'required-account-cpf';
interface FormValues {
  cpf: string;
}

const RequiredCPFModal = () => {
  const breakpoints = Grid.useBreakpoint();
  const [form] = Form.useForm<FormValues>();
  const { onSetCPF, savingCPF } = useSetAccountCPF();

  const onFinish = ({ cpf }: FormValues) => onSetCPF(cpf.replace(/\D/g, ''));

  return (
    <AppModal
      open
      fullScreen={!breakpoints.md}
      title="Complete seu cadastro"
      blocking
      footer={
        <Button
          type="primary"
          htmlType="submit"
          form={FORM_ID}
          loading={savingCPF}
        >
          Salvar CPF
        </Button>
      }
    >
      <Typography.Paragraph>
        Informe seu CPF para concluir o cadastro. Ele será protegido e
        apresentado apenas de forma ocultada.
      </Typography.Paragraph>
      <Form
        form={form}
        id={FORM_ID}
        layout="vertical"
        disabled={savingCPF}
        onFinish={(values) => onFinish(values).catch(() => undefined)}
      >
        <Form.Item
          name="cpf"
          label="CPF"
          rules={[requiredRule(), CPFRule()]}
          getValueFromEvent={(event) => maskBRCPF(event.target.value)}
        >
          <Input
            placeholder="123.456.789-01"
            autoComplete="off"
            inputMode="numeric"
            maxLength={14}
          />
        </Form.Item>
      </Form>
    </AppModal>
  );
};

export default RequiredCPFModal;
